// extracted by mini-css-extract-plugin
export default {"color":"Registration_color__v7njB","options":"Registration_options__wNL9G","link":"Registration_link__BCck0"};